<div class="row" *ngIf="isLoading">
  <div
    class="col-12 col-sm-6 col-lg-3"
    *ngFor="let item of [1, 2, 3, 4]; let isFirst = first; let isLast = last"
    [ngClass]="{ 'pl-0': isFirst, 'pr-0': isLast }"
  >
    <div class="card p-4 rounded-2xl skeleton-card bg-white dark:bg-coal-700">
      <!-- Title + count -->
      <div class="flex justify-between items-start mb-4">
        <div class="flex flex-col gap-2">
          <div
            class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded"
            style="width: 100px; height: 18px"
          ></div>
          <div
            class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded"
            style="width: 140px; height: 14px"
          ></div>
        </div>

        <div
          class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded"
          style="width: 50px; height: 28px"
        ></div>
      </div>

      <!-- Progress section -->
      <div class="flex items-center gap-3 mt-5">
        <div
          class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded"
          style="width: 60px; height: 14px"
        ></div>

        <div class="flex-1">
          <div
            class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded"
            style="width: 100%; height: 8px"
          ></div>
        </div>

        <div
          class="shimmer-item bg-gray-300 dark:bg-coal-700 rounded"
          style="width: 40px; height: 14px"
        ></div>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="fieldsData?.length && !isLoading">
  <div
    class="col-12 col-sm-6 col-lg-3"
    *ngFor="let option of fieldsData; let isFirst = first; let isLast = last"
    (click)="navigateToTasks(option.label)"
    [ngClass]="{ 'pl-0': isFirst, 'pr-0': isLast }"
  >
    <div
      class="relative card bg-cover bg-center text-white p-4 rounded-2xl overflow-hidden cursor-pointer"
    >
      <!-- Background Gradient Based on Label -->
      <div
        class="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
        [ngStyle]="{
          background: getGradient(option.label),
        }"
      ></div>

      <div class="relative">
        <div class="flex justify-between items-start">
          <div>
            <div
              class="card-title font-default font-bold"
              [ngClass]="getLabelClass(option.label)"
            >
              {{ option.label }}
            </div>
            <div class="card-subtitle text-sm text-gray-700">
              {{ option.subtitle }}
            </div>
          </div>
          <div class="text-2.5xl font-medium text-gray-900">
            {{ option.count }}
          </div>
        </div>

        <div class="flex gap-4 items-center mt-6">
          <span class="text-2sm text-gray-600">Progress</span>
          <div
            class="flex-1 progress-bar-container h-2 rounded w-1/5"
            [ngClass]="getProgressBarContainerClass(option.label)"
          >
            <div
              class="progress-bar h-full rounded w-1/5"
              [ngStyle]="{ width: option.progress + '%' }"
              [ngClass]="getProgressBarFillClass(option.label)"
            ></div>
          </div>

          <div
            class="more underline text-sm whitespace-nowrap ml-2 text-gray-600"
          >
            More ›
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
